module.exports = __webpack_public_path__ + "img/backbone-logo.f64fc705.png";